import { render, staticRenderFns } from "./Flows.vue?vue&type=template&id=5db9221f&scoped=true"
import script from "./Flows.vue?vue&type=script&lang=js"
export * from "./Flows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db9221f",
  null
  
)

export default component.exports